'use client'

import {
  Link,
  useLocation,
  // useNavigate, 
  // useParams 
} from 'react-router-dom';
import {
  // useContext, 
  useEffect
} from 'react';
import Logo from 'assets/images/Talamus-Logo-Blanc.png';
//import MobileMenu from './mobile-menu'
//import { usePathname, useSearchParams, useRouter } from 'next/navigation'
import { IPublicClientApplication } from "@azure/msal-browser"
import {
  AuthenticatedTemplate,
  useIsAuthenticated,
  useMsal
} from "@azure/msal-react"
import { loginRequest } from 'AuthConfig'
import { useLanguage, Lang } from 'contexts/LanguageContext'
import { ServiceCoursesProvider } from 'api/ServiceCoursesProvider';
import { useSubscription } from 'contexts/SubscriptionContext';
import DesktopNav from './desktop-nav';
import MobileNav from './mobile-nav';
import { useIsMobile } from 'hooks/useIsMobile';
import { trackEvent } from 'utils/gtag';

export default function Header() {
  const msal = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const { subscription, subscriptionError, setSubscription, setSubscriptionError } = useSubscription();
  const { lang, onLanguageChange, res } = useLanguage();
  const location = useLocation();
  const currentPath = location.pathname;
  const pathParts = currentPath.split('/').filter(Boolean); // Split the path into parts and remove empty parts
  const langArr: Lang[] = ["fr", "en"]
  const isMobile = useIsMobile(768); // Détection mobile avec breakpoint à 768px
  
  let language: Lang = langArr.includes(pathParts[0] as Lang) ? pathParts[0] as Lang : lang;

  useEffect(() => {
    if (language !== lang) {
      if (onLanguageChange) {
        onLanguageChange(language);
      }
    }

    if (pathParts[0] !== language) {
      if (langArr.includes(pathParts[0] as Lang)) {
        //navigate(`/${language}/${pathParts.slice(1).join('/')}`);
      }
      else {
        //navigate(`/${language}/${pathParts.join('/')}`);
      }
    }
  }, [pathParts[0]]);

  useEffect(() => {
    if (isAuthenticated && !currentPath.includes('/invitations')) {
      getSubscription();
    }
  }, [isAuthenticated]);

  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  function signInClickHandler(instance: IPublicClientApplication) {
    loginRequest.extraQueryParameters = {
      ui_locales: lang === 'fr' ? "fr-ca" : 'en-ca' // Change this to the desired locale
    };
    // Open B2C login with a popup window

    const popupWidth = 900;
    const popupHeight = 850;
    const left = Math.round(window.screenX + (window.outerWidth - popupWidth) / 2);
    const top = Math.round(window.screenY + (window.outerHeight - popupHeight) / 2);

    instance.loginPopup({
      ...loginRequest,
      popupWindowAttributes: {
        popupSize: { width: popupWidth, height: popupHeight },
        popupPosition: { left, top }
      }
    })
      .catch(err => {
        if (err.errorCode === 'user_cancelled') {
          // Handle the scenario where the user cancelled the login
          console.log('User cancelled the login');
        } else {
          // Handle other errors
          console.log('Login failed with error:', err);
        }
      });

    // another method could open that with a redirect 
    // instance.loginRedirect()
  }

  function signOutClickHandler(instance: IPublicClientApplication) {
    instance.logoutRedirect();
    cleanStorage();
  }

  function UserInfo() {
    return (
      <>
        <div className="headerUserInfo md:grid md:grid-cols-12">
          <div className="hidden md:block md:col-span-4 lg:col-span-4">&nbsp;</div>
          <div className="md:col-span-8 lg:col-span-8 text-right">
            {subscriptionError ? (
              <span className="text-red-600">{res.subscriptionFetchError || "Erreur lors de la récupération de l'abonnement."}</span>
            ) : (
              <>
                {(subscription?.abonnement?.titre) ? res["Votre type d'abonnement"] + subscription.abonnement.titre[lang] : ""}
                {(subscription?.dateEcheance) ? " | " + res["Date d'échéance"] + subscription.dateEcheance.split("T")[0] : ""}
                {(subscription?.nombreInscriptions !== undefined && subscription?.nombreInscriptions !== null) ? " | " + res["Nombre de participation"] + subscription.nombreInscriptions : ""}
              </>
            )}
          </div>
        </div>
      </>
    )
  }

  async function getSubscription() {
    if (isAuthenticated) {
      let subscriptionId;
      try {
        setSubscriptionError(null); // Clear previous error
        let currentSubscription = await ServiceCoursesProvider.provider.getSubscriptions(msal, lang);
        if (!currentSubscription || currentSubscription.length === 0 || !currentSubscription.abonnement) {
          // no subscription found
          // call the API to create a new subscription
          console.log("header - call the API to create a new subscription");
          currentSubscription = await ServiceCoursesProvider.provider.createSubscription(msal, lang);
          if (currentSubscription) {
            trackEvent('nouvel_abonnement', {
              subscription_id: currentSubscription.id
            });
            setSubscription(currentSubscription);
          }
        } else {
          setSubscription(currentSubscription);
        }
        subscriptionId = currentSubscription?.abonnement?.id;
        sessionStorage.setItem("subscriptionId", subscriptionId);
        sessionStorage.setItem("userSubscriptionId", currentSubscription?.id);
      } catch (error: any) {
        setSubscriptionError(error?.message || 'Erreur lors de la récupération de l\'abonnement.');
        setSubscription(null);
      }
    }
  }

  function cleanStorage() {
    sessionStorage.removeItem('invitationCode');
    sessionStorage.removeItem('subscriptionUpdated');
    sessionStorage.removeItem('subscriptionId');
    sessionStorage.removeItem('userSubscriptionId');
  }

  return (
    <header className="navbar-sticky w-full z-30">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-20">
          {/* Site branding */}
          <div className="shrink-0 mr-4">
            {/* Logo */}
            <Link to="https://talamus.pro" target="_blank" className="block" aria-label="Talamus">
              <img src={Logo} width={80} alt="Talamus" />
              {/* <svg className="w-8 h-8 fill-current text-purple-600" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                <path d="M31.952 14.751a260.51 260.51 0 00-4.359-4.407C23.932 6.734 20.16 3.182 16.171 0c1.634.017 3.21.28 4.692.751 3.487 3.114 6.846 6.398 10.163 9.737.493 1.346.811 2.776.926 4.262zm-1.388 7.883c-2.496-2.597-5.051-5.12-7.737-7.471-3.706-3.246-10.693-9.81-15.736-7.418-4.552 2.158-4.717 10.543-4.96 16.238A15.926 15.926 0 010 16C0 9.799 3.528 4.421 8.686 1.766c1.82.593 3.593 1.675 5.038 2.587 6.569 4.14 12.29 9.71 17.792 15.57-.237.94-.557 1.846-.952 2.711zm-4.505 5.81a56.161 56.161 0 00-1.007-.823c-2.574-2.054-6.087-4.805-9.394-4.044-3.022.695-4.264 4.267-4.97 7.52a15.945 15.945 0 01-3.665-1.85c.366-3.242.89-6.675 2.405-9.364 2.315-4.107 6.287-3.072 9.613-1.132 3.36 1.96 6.417 4.572 9.313 7.417a16.097 16.097 0 01-2.295 2.275z" />
              </svg> */}
            </Link>
          </div>

          {/* Navigation conditionnelle selon la taille d'écran */}
          {isMobile ? (
            <MobileNav
              language={language}
              pathParts={pathParts}
              signInClickHandler={signInClickHandler}
              signOutClickHandler={signOutClickHandler}
            />
          ) : (
            <DesktopNav 
              language={language}
              pathParts={pathParts}
              signInClickHandler={signInClickHandler}
              signOutClickHandler={signOutClickHandler}
            />
          )}
        </div>

        <AuthenticatedTemplate>
          <UserInfo />
        </AuthenticatedTemplate>
      </div>
    </header>
  )
}
